export default __webpack_public_path__ + "static/media/checkMarkAccept.7215dad1.svg";